import { render, staticRenderFns } from "./addWorkmodal.vue?vue&type=template&id=0e2ac5d8&"
import script from "./addWorkmodal.vue?vue&type=script&lang=js&"
export * from "./addWorkmodal.vue?vue&type=script&lang=js&"
import style0 from "./addWorkmodal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports